require('../bootstrap');
require('bootstrap');

// import for vuex
// import store from './store'
import Swal from '../components/swal'
import router from './router'

const files = require.context('./views/', true, /\.vue$/i)
files.keys().map(key => {
    Vue.component(key.split('/').pop().split('.')[0], files(key).default)
})


Vue.config.productionTip = false

const app = new Vue({
    el: '#apps',
    router: router,
    // store,
    data: {
        role: 'service',
    }
});